
searchBoxDirective = ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'components/searchBox'
    require: '?ngModel'
    scope: search: '&', placeholder: '@'
    controllerAs: 'ctrl'
    bindToController: true

    controller: ($element) ->
        'ngInject'

        ngModel = $element.controller('ngModel')
        if not ngModel? then return

        @modelOptions =
            updateOn: 'default blur',
            debounce: default: 200, blur: 0

        ngModel.$render = =>
            @searchText = ngModel.$viewValue || ''
            return

        @change = ->
            query = @searchText
            ngModel.$setViewValue(@searchText)
            return

        @clear = ->
            ngModel.$setViewValue(undefined)
            ngModel.$render()
            return

        return



module.directive 'dybSearchBox', searchBoxDirective
